import { ICategory } from '@/models/categories.model';

export const removeCategoryById = (items: ICategory[], idToDelete: string) => {
  let isFound = false;

  return items.reduce((acc, item) => {
    if (isFound) {
      return [...acc, item];
    }

    if (item.id === idToDelete) {
      isFound = true;
      return acc;
    }

    const updatedSubcategories = removeCategoryById(item.sub_categories || [], idToDelete);

    acc.push({
      ...item,
      sub_categories: updatedSubcategories,
    });

    return acc;
  }, [] as ICategory[]);
};
